exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tags-wrap{width:100%;height:0.8rem;background-color:#FFFFFF;position: fixed;z-index:2;left:0;top:1.02rem;border-bottom:#DCDCDC solid 1px;display:flex;display:-webkit-flex;}\n.tags-wrap .tags{width:25%;height:100%;text-align:center;font-size:0.28rem;line-height:0.8rem;}\n.tags-wrap .tags.active{border-bottom:#E42321 1px solid;}", ""]);

// exports
